export default "__VITE_ASSET__BGlxJIFP__"